import React from 'react'
import { View, Text, Linking, Pressable } from 'react-native'
import { commonStyle } from '../../assets/TextStyles/TextStyles'
import confirm from '../../assets/sounds/confirm.mp4'
import { playSound } from '../../utils/AudioPlayer'
//import pdf from '../../assets/pdf/Stek_Sahkolan_Ilmastotalkoot_opas.pdf'

const Credits = () => {
  const handleDownload = () => {
    const pdf = require('../../assets/pdf/Stek_Sahkolan_Ilmastotalkoot_opas.pdf')
    Linking.openURL(pdf)
    playSound(confirm)
  }

  return (
    <View>
      <Text style={commonStyle.h2}>Tiedot</Text>

      <Text style={commonStyle.h4}>Koulumateriaalit</Text>
      <Pressable onPress={handleDownload}><Text style={commonStyle.link}>Opettajan opas</Text></Pressable>

      <Text style={commonStyle.h4}>STEK yhteyshenkilöt:</Text>
      <Text style={commonStyle.displayText0}>Kirsi Gimishanov, Timo Kekkonen</Text>

      <Text style={commonStyle.h4}>Pelisuunnittelu, projektikoordinaattori:</Text>
      <Text style={commonStyle.displayText0}>Mika Mäkelä / Ludum Effugium Oy, Kale Aalto / Ludum Effugium Oy</Text>

      <Text style={commonStyle.h4}>Ohjelmointi:</Text>
      <Text style={commonStyle.displayText0}>Mikko Honkanen</Text>

      <Text style={commonStyle.h4}>Graafinen suunnittelu:</Text>
      <Text style={commonStyle.displayText0}>Peter Talvitie / Ivermedia</Text>

      <Text style={commonStyle.h4}>Pedagoginen asiantuntija:</Text>
      <Text style={commonStyle.displayText0}>Suvi Huovelin</Text>

      <Text style={commonStyle.h4}>Heureka yhteyshenkilö:</Text>
      <Text style={commonStyle.displayText0}>Sami Pihkala</Text>

      <Text style={commonStyle.h4}>SET-hankkeen asiantuntijat:</Text>
      <Text style={commonStyle.displayText0}>Eva Heiskanen, Kaisa Matschoss, Vera Järvenreuna, Armi Temmes</Text>

      <Text style={commonStyle.displayTextSmall}>
        Sähkölän ilmastotalkoot peli pohjautuu Suomen Akatemian Smart Energy Transition -hankkeen (SET) yhteydessä toteutettuun oppimislautapeliin.
      </Text>
    </View>
  )
}

export default Credits
